// adapted from https://github.com/primefaces/primeng/blob/200ef8829eb45b5ed66d8ae7a35c99dc0e5af707/packages/themes/src/presets/aura/skeleton/index.ts
export const skeleton = {
  root: {
    borderRadius: "{content.border.radius}",
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.bg-grey-contrast}",
        animationBackground: "rgba(255,255,255,0.4)",
      },
    },
    dark: {
      root: {
        background: "{surface.bg-grey-contrast}",
        animationBackground: "rgba(255, 255, 255, 0.04)",
      },
    },
  },
};
